<section class="left-nav-wrapper">
  <div
    *ngIf="editor && editor.initComplete"
    [ngClass]="{ readOnly: (readOnly | async) }"
    class="d-flex justify-content-between">
    <div>
      <h1 class="d-inline-block me-2">{{ headerName | async }}</h1>
      @if ((headerEmployeeType | async) != '' && (headerStatus | async) != '') {
        <small>({{ headerEmployeeType | async }} - {{ headerStatus | async }})</small>
      }
    </div>
    <div>
      <button
        class="btn btn-secondary"
        (click)="editor.onDeleteClick()"
        cpGTagEvent
        [params]="{ event_label: 'people_edit_delete_person' }"
        *ngIf="
          !isEmployeePortal &&
          (person | async).Id &&
          !(person | async).LastPaid &&
          !(person | async).HasPickupOrSuccessorFigures
        "
        [disabled]="readOnly | async">
        Delete Person
      </button>
      <!-- save/cancel not on tabs like earnings & deductions where save logic is handled in modals-->
      <!-- task 9736. show & enable 'Cancel' button on every tab when creating a new person,
        as this abandons all changes to the person record.
      -->
      <button
        *ngIf="
          !isEmployeePortal &&
          (mode == 'add' ||
            (editor.activeTabIdx !== 3 && editor.activeTabIdx !== 5 && editor.activeTabIdx !== 6))
        "
        cpGTagEvent
        [params]="{ event_label: 'people_edit_cancel' }"
        class="btn btn-secondary ms-2"
        (click)="editor.onCancelClick()"
        [disabled]="!(currentTabStatus | async).IsDirty && mode == 'edit'">
        Cancel
      </button>
      <button
        [disabled]="readOnly | async"
        *ngIf="!isEmployeePortal && mode === 'add'"
        type="button"
        class="btn btn-primary ms-2"
        cpGTagEvent
        [params]="{ event_label: 'people_edit_save_person' }"
        (click)="editor.onContinueClick()">
        <span>{{ saveButtonText | async }}</span>
      </button>
      <button
        *ngIf="
          !isEmployeePortal &&
          mode === 'edit' &&
          editor.activeTabIdx !== 3 &&
          editor.activeTabIdx !== 5 &&
          editor.activeTabIdx !== 6
        "
        type="button"
        cpGTagEvent
        [params]="{ event_label: 'people_edit_save_person' }"
        class="btn btn-primary ms-2"
        (click)="editor.onSaveClick()"
        [disabled]="!(currentTabStatus | async).IsDirty || (readOnly | async)">
        <span>Save</span>
      </button>
      <div class="text-center pt-1" *ngIf="readOnly | async">
        <strong
          ><em>{{ editor.clientLockMsg }}</em></strong
        >
      </div>
      <div class="text-center pt-1" *ngIf="isEmployeePortal && (headerStatus | async) != 'Active'">
        <strong><em>View Only - Inactive</em></strong>
      </div>
    </div>
  </div>
  <person-editor
    #personEditor
    [clientCode]="clientCode"
    [personId]="personId"
    [mode]="mode"
    [addToPayrollRoute]="addToPayrollRoute"
    (clientOrPersonNotFound)="clientOrPersonNotFound()"
    (returnToPayroll)="returnToPayroll($event)"
    (onEditorLeave)="onEditorLeave()">
  </person-editor>
</section>
